/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 17th 2026, 8:36:16 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import create from "zustand";

export interface IStore {
  csrfToken: string;
  setCSRFToken: (csrfToken: string) => void;
}

export const useStore = create<IStore>((set) => {
  return {
    csrfToken: null,
    setCSRFToken: (csrfToken) => set((state) => ({ csrfToken })),
  };
});
